<!-- 購入期限の注意書き -->
<template>
  <div class="warning-block">
    <div class="warning-title">
      <img
        class="warning-icon"
        :src="require('@/assets/img/icon/svg/icon-warning-triangle.svg')"
        alt=""
      />
      購入が未完了です
    </div>
    <div class="warning-message">
      {{
        limit
      }}までに特急券一覧画面または以下の「この特急券を購入する」ボタンから購入を完了してください。
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreBookingResultLimitCaution",
  props: {
    limit: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.warning-block {
  line-height: 18px;
  align-items: center;
  border-radius: 8px;
  padding: 15px 36px;
  flex-direction: column;
  justify-content: center;
  background: #faf3eb;
}

.warning-title {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 13px;
  font-weight: 800;
  margin-bottom: 8px;
  gap: 5px;
  color: #da3b31;
}

.warning-icon {
  width: 18px;
  height: 18px;
}

.warning-message {
  text-align: left;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.6px;
  color: #da3b31;
}
</style>
